var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('global-footer', {
    attrs: {
      "brand": _vm.brand
    },
    scopedSlots: _vm._u([{
      key: "links",
      fn: function fn() {
        return [_c('a', {
          attrs: {
            "href": "/protocol/sample_2257.html",
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.exemptionStatement')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "/protocol/terms.html",
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.terms')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "/protocol/privacy.html",
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.privacy')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "/protocol/refund.html",
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.refundPolicy')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "/protocol/privacy_notice.html",
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.privacyNotice')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "/protocol/cookie.html",
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.cookiePolicy')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "/protocol/user_choice.html",
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.userChoice')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "/protocol/intellectual.html",
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.propertyRights')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": _vm.getHeaderLink('/anti-bullying.html'),
            "target": "_bank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.antiBullying')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": _vm.getHeaderLink('/child-assault-preventing.html'),
            "target": "_bank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.childAssaultPreventing')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "/protocol/child-safety-policy-agreement.html",
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('menu.childSafetyPolicyAgreement')))])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };